import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSeo } from "@/lib/seo";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import StoryDemo from "@/components/landing/StoryDemo";
import Features from "@/components/landing/Features";
import HowItWorks from "@/components/landing/HowItWorks";
import Pricing from "@/components/landing/Pricing";
import Safety from "@/components/landing/Safety";
import Channel from "@/components/landing/Channel";
import FAQ from "@/components/landing/FAQ";
import FinalCTA from "@/components/landing/FinalCTA";
import Footer from "@/components/landing/Footer";
import StickyMobileCTA from "@/components/landing/StickyMobileCTA";

const LandingPage = () => {
  useSeo({ path: "/" });
  const { hash } = useLocation();

  // Переход по якорю с другой страницы: браузер скроллит до того, как React отрисует секции,
  // поэтому доводим сами — дважды, второй раз после подгрузки сказки дня, сдвигающей вёрстку.
  useEffect(() => {
    if (!hash) return;
    const scroll = () => document.querySelector(hash)?.scrollIntoView({ behavior: "smooth", block: "start" });
    const t1 = window.setTimeout(scroll, 100);
    const t2 = window.setTimeout(scroll, 1200);
    return () => {
      window.clearTimeout(t1);
      window.clearTimeout(t2);
    };
  }, [hash]);

  return (
    <div data-testid="landing-page" className="min-h-screen bg-night-900">
      <Header />
      <Hero />
      <StoryDemo />
      <Features />
      <HowItWorks />
      <Pricing />
      <Safety />
      <Channel />
      <FAQ />
      <FinalCTA />
      <Footer />
      <StickyMobileCTA />
    </div>
  );
};

export default LandingPage;
